import React from 'react';

export default function ResizeHandle({ ariaLabel }) {
  return (
    <svg
      width='448px'
      height='160px'
      viewBox='0 0 448 160'
      aria-label={ariaLabel}
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g id='grip-lines' fill='#9C9C9C' fillRule='nonzero'>
          <path
            d='M432,112 L16,112 C7.2,112 0,119.2 0,128 L0,144 C0,152.8 7.2,160 16,160 L432,160 C440.8,160 448,152.8 448,144 L448,128 C448,119.2 440.8,112 432,112 Z M432,0 L16,0 C7.2,0 0,7.2 0,16 L0,32 C0,40.8 7.2,48 16,48 L432,48 C440.8,48 448,40.8 448,32 L448,16 C448,7.2 440.8,0 432,0 Z'
            id='Shape'
          />
        </g>
      </g>
    </svg>
  );
}
